module.exports = __webpack_public_path__ + "static/img/draw-bg.93a82b68.png";